import { useResolvedDesignSystemComponent } from 'ext-ui/design-system/DesignSystemChannel'
import GeneratedLatestOverlay, {
  OverlayProps,
} from 'ext-ui/design-system/generated/latest/components/Overlay/Overlay'
import GeneratedLiveOverlay from 'ext-ui/design-system/generated/live/components/Overlay/Overlay'
import React, { ReactElement } from 'react'

function renderDesignSystemOverlay(
  Component: typeof GeneratedLiveOverlay,
  channel: 'live' | 'latest',
  props: OverlayProps,
): ReactElement {
  return <Component {...props} data-design-system-channel={channel} />
}

function LiveOverlay(props: OverlayProps): ReactElement {
  return renderDesignSystemOverlay(GeneratedLiveOverlay, 'live', props)
}

function LatestOverlay(props: OverlayProps): ReactElement {
  return renderDesignSystemOverlay(GeneratedLatestOverlay, 'latest', props)
}

function Overlay(props: OverlayProps): ReactElement {
  const ResolvedOverlay = useResolvedDesignSystemComponent(
    LiveOverlay,
    LatestOverlay,
  )

  return <ResolvedOverlay {...props} />
}

export default Overlay
export type { OverlayProps }
